import { render } from "./LoanType.vue?vue&type=template&id=1c92d7d3"
import script from "./LoanType.vue?vue&type=script&lang=js"
export * from "./LoanType.vue?vue&type=script&lang=js"

import exportComponent from "../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__